import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";

import { userSlice } from "@/store/user";
import { RootState } from "@/store";
import { checkPermission } from "@/store/common";

import { parseCookies, setCookie } from 'nookies';
import * as fetchUtil from "@/util/fetchUtil";
//import { Buffer } from 'buffer'; //'Buffer' is declared but its value never read.

import moment from 'moment';

const TOKEN_COOKIE_NAME = "cfx_token";

//Page Props
type Props = {
  error ?: {message: string},
  children?: JSX.Element[],
}

//Main
// 認証確認の古い実装。新しい実装は末尾に作成
/*
const CheckAuth2 = (props: Props): JSX.Element => {
  const router = useRouter();

  //Store, Dispatcher
  const dispatch = useDispatch();
  const userStore = useSelector((state: RootState) => state.user);

  //DEF componentDidMount
  const componentDidMount = async ()=>{
    //認証
    const a = await auth();
    if(a) {
      //何もしない
    }
    else {
      //エラー画面に遷移する
      //router.push('/error');
      //認証画面にリダイレクトする
      console.log(location.href);
      window.location.href = process.env.NEXT_PUBLIC_SSO_ENDPOINT;
    }
  };

  //DEF componentWillUnmount
  const componentWillUnmount = ()=>{
  }

  useEffect(() => {
    //DO componentWillUnmount
    componentDidMount.bind(this)();
    return ()=>{
      //DO componentWillUnmount
      componentWillUnmount.bind(this)();
    }
  }, []); //Empty

  //componentDidUpdate
  // useEffect(() => {
  // }, componentDidUpdateTarget); //MoniteringTarget

  //handler
  const auth = async () => {
    try{
      //Cookie
      const cookie = parseCookies(null);
  
      //認証チェック
      if(cookie.sms_code || cookie.sms_token || cookie.cfx_token) {
        //認証
        const suburl = process.env.NEXT_PUBLIC_AUTHORIZER_API; //"/authorizer";
        const params = {
          authorizationToken: 
            cookie.sms_code ? "code=" + cookie.sms_code :
            cookie.cfx_token ? "token=" + cookie.cfx_token :
            cookie.sms_token ? "token=" + cookie.sms_token :
            "",
          userid:userStore.user_id,
          username: userStore.name,
        };
        // const response = fetch(url)
        const response = await fetchUtil.post(suburl, params, userStore);
        const data = await response.json();
        //{"principalId":"user","policyDocument":{"Version":"2012-10-17","Statement":[{"Action":"execute-api:Invoke","Effect":"Deny"}]},"context":{"result":"bnVsbA=="}}
        //{"principalId":"user","policyDocument":{"Version":"2012-10-17","Statement":[{"Action":"execute-api:Invoke","Effect":"Allow"}]},"context":{"result":"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"}}
        let effect;
        let result;
        let user;
        let permissions;
        let token;
        if(data.policyDocument && data.policyDocument.Statement && data.policyDocument.Statement.length > 0){
          effect = data.policyDocument.Statement[0].Effect;
        }
        if(data.context && data.context.result) {
          // result = JSON.parse(atob(data.context.result));
          result = JSON.parse(Buffer.from(data.context.result, 'base64').toString());
          //{"status":20,"message":"Success","result":{"user":{"company_id":"ã","update_datetime":"20210902120000","user_id":"hutsumi@bysystems.jp","company":"BYS","name":"åæµ· ä¹å¾³"},"permissions":["enable-sej"],"token":{"access_token":"eyJraWQiOiJUM0xxdk9FK0hxVWZQN3F4a3NFRWdlSjFlK1d3RjBmY04xbXV1cTA5ZVNBPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI5OWFiZTc3YS1jNmExLTQ4NzYtOWE4My1iODkxNWU5N2M3NzUiLCJ0b2tlbl91c2UiOiJhY2Nlc3MiLCJzY29wZSI6Im9wZW5pZCIsImF1dGhfdGltZSI6MTYzMTcwOTg2NiwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLmFwLW5vcnRoZWFzdC0xLmFtYXpvbmF3cy5jb21cL2FwLW5vcnRoZWFzdC0xX2NsMzFkaHdLUyIsImV4cCI6MTYzMTc1Nzg2NiwiaWF0IjoxNjMxNzA5ODY2LCJ2ZXJzaW9uIjoyLCJqdGkiOiIzMmQ3ZDg3NC03NTdjLTQwODItOGFjMS1lMjBkNDU2NDdlMGIiLCJjbGllbnRfaWQiOiI3MGJhb2o4NG8yanZwNjE5bmRuMzhxb2c4MyIsInVzZXJuYW1lIjoiOTlhYmU3N2EtYzZhMS00ODc2LTlhODMtYjg5MTVlOTdjNzc1In0.akZJK3DrzQFDFJLCU_djakwKM6F5yYifQ2Zma3j9iHNjZC6nj1rxhE14zHT6vQu6JZb0O4SGDrlW7SdeuH-HUigQTcnH01EE2MACbtOw1JL4N7h_RpUlcEQq6t_P-KyecvFo4M7ZRryG0ishx84_rHxo_AbjkIdVS3kACXyDEfVhtKz2GiVpAxQ2J_M8An2mt3gHqEI7rkV1TaMQWnkAHcEOCV1QFuFfLfxv7h-qV-GzsfiYvtUn5Bf6rQEAps3VtHd_m_GgGpl_EVt0ZpPtKbrA-Gdcr-12mpeQ97PMaiER-hp1-qdmiFm9KjQKN_B5fvTzVt-iUMQ0AKuYn1iuUA","id_token":"eyJraWQiOiIzbmVSVlVKenRNY01id05ha3MwZWRmb2NlQm9Nd1lcL1wvV0wzUElOXC9odzJVPSIsImFsZyI6IlJTMjU2In0.eyJhdF9oYXNoIjoiYUVPelJreDNlekpDYnNzaW4yMVZRdyIsInN1YiI6Ijk5YWJlNzdhLWM2YTEtNDg3Ni05YTgzLWI4OTE1ZTk3Yzc3NSIsImF1ZCI6IjcwYmFvajg0bzJqdnA2MTluZG4zOHFvZzgzIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsInRva2VuX3VzZSI6ImlkIiwiYXV0aF90aW1lIjoxNjMxNzA5ODY2LCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuYXAtbm9ydGhlYXN0LTEuYW1hem9uYXdzLmNvbVwvYXAtbm9ydGhlYXN0LTFfY2wzMWRod0tTIiwibmFtZSI6IuWGhea1tyDkuYXlvrMiLCJjb2duaXRvOnVzZXJuYW1lIjoiOTlhYmU3N2EtYzZhMS00ODc2LTlhODMtYjg5MTVlOTdjNzc1IiwiZXhwIjoxNjMxNzEzNDY2LCJpYXQiOjE2MzE3MDk4NjYsImVtYWlsIjoiaHV0c3VtaUBieXN5c3RlbXMuanAifQ.XilRCYlcTdhtd-iK-P-HtppJHMstVPlcbLFU4rYQv66_DiUn7KqTMmVUSqqpBit6Vl1MIIv9cnEZI85zYzxVkCF9kEEl8hGALzQSsPS7mXzZI2IGedL7u9u90V5tBd2QWrFdwJw0ujhqaoQeTBswmmMpdv2csqtRHEBqw-Q4Be66avyx0rMiz7Zk44O_nim8uq3YlkK13Ix_xghadgtsuxyCHF5N4LvDURUOW5M74ADh6cH3xWdl1nPOAeI4qXUJtA2KM4yBVmcmkH7G-ryDU67hPTQ5oRvBSXYiY_vladAnwD-z-dRPdUAw1dcicHukNuCCDWstlSNDbeBYe0Nvdw","expires":"Fri, 15 Oct 2021 12:44:26 GMT"}}}

          if(result && result.result) {
            if(result.result.user) {
              user = result.result.user;
            }
            if(result.result.permissions) {
              permissions = result.result.permissions;
            }
            if(result.result.token) {
              token = result.result.token.access_token;
            }
          }
        }

        if(effect == 'Allow' && user && token) {
          dispatch(userSlice.actions.success());
          dispatch(userSlice.actions.setUserState({...user, permissions: permissions && Array.isArray(permissions) ? permissions : [], token: token}));

          setCookie(null, 'sms_token', token, {
            maxAge: parseInt(process.env.NEXT_PUBLIC_AUTHTOKEN_ALIVE_MIN) * 60, //60分
          });
          setCookie(null, 'cfx_token', token, {
            maxAge: parseInt(process.env.NEXT_PUBLIC_AUTHTOKEN_ALIVE_MIN) * 60, //60分
            domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
          });

          return true;
        }
      }

      //認証NG時
      dispatch(userSlice.actions.error({message: '認証できませんでした'}));
      return false;

    }
    catch(err) {
      console.log(err);
      dispatch(userSlice.actions.error(err));
      //認証NG時
      return false;
    }


  }


  return (
    <>
      {userStore.isAuthed ? props.children : []}
    </>
  );
};
*/

// 認証状態
type AuthState =
  | null // 何もしていない状態
  | "begin" // 認証開始
  | "authorized" // 認証済み
  | "unauthorized"; // 未認証

const AUTHORIZER_API = process.env['NEXT_PUBLIC_AUTHORIZER_API'];
const SSO_ENDPOINT = process.env['NEXT_PUBLIC_SSO_ENDPOINT'];
const API_ENDPOINT = process.env["NEXT_PUBLIC_API_ENDPOINT"];

/**
 * 認証状態フック
 */
function useAuthState(): AuthState {
  const router = useRouter();
  const [state, setState] = useState<AuthState>(null); // TODO 広域に保持するほうが適切 →CheckAuthが複数個所で使われていると成り立たないため
  // reduxに認証情報が格納されている模様
  const dispatch = useDispatch();
  const userStore = useSelector((state: RootState) => state.user);

  useEffect(() => {
    const now = moment();
    const start = moment().startOf('day').add(process.env.NEXT_PUBLIC_DB_START, 'hour');
    const end = moment().startOf('day').add(process.env.NEXT_PUBLIC_DB_END, 'hour');
    if (!now.isBetween(start, end)) {
      console.log("サービス時間外");
      router.push('/outsideservicehours');
      return null;
    }
    if (!router.isReady || state !== null) {
      // next/routerがreadyではない、stateが進んでいる
      return null;
    }

    setState("begin");
    fetchUtil.block(); // APIリクエストをブロック
    const code = router.query['code'];
    if (code) {
      // ?code=xxxを取り除く
      const params = new URLSearchParams();
      for (const [key ,val] of Object.entries(router.query)) {
        if (key === "code") {
          continue;
        }
        for (const v of Array.isArray(val) ? val : [val]) {
          params.append(key, v);
        }
      }
      const query = params.toString();
      router.replace(`${router.pathname}${query ? "?" + query : ""}`, void 0, { shallow: true });
    }

    (async () => {
      try {
        // ?codeまたはアクセストークン（Cookieに設定）で認証
        const url = new URL(AUTHORIZER_API, API_ENDPOINT); // API_ENDPOINTは使わずに捨てる
        if (typeof code === "string") {
          url.searchParams.set("code", code); // Authorizerで本文を見ることはできないので、クエリに設定 (ヘッダの操作はfetchUtilで隠されている)
        }

        const headers = {}
        const cookies = parseCookies(null);
        if (cookies[TOKEN_COOKIE_NAME]) {
          headers["Authorization"] = `Bearer ${cookies[TOKEN_COOKIE_NAME]}`;
        }

        let response: Response;
        try {
          response = await fetchUtil.postAnon(`${url.pathname}${url.search}`, {}, null, headers);
        } catch (e) {
          // CORSエラーの場合 →Authorizerが拒否した場合は、HTTP 403で返却されCORSヘッダが無くなっている
          dispatch(userSlice.actions.error({message: '認証できませんでした'}));
          setState("unauthorized");
          fetchUtil.authorizationFailure(new Error("認証できませんでした")); // APIリクエストのブロックを解除(常に失敗する)
          return;
        }
        if (response.status === 403) {
          dispatch(userSlice.actions.error({message: '認証できませんでした'}));
          setState("unauthorized");
          fetchUtil.authorizationFailure(new Error("認証できませんでした")); // APIリクエストのブロックを解除(常に失敗する)
          return;
        }
        if (!response.ok) {
          // 正常にレスポンスが返せない場合
          throw new Error("failed to authenticate."); // TODO error behavior
        }
        const result = await response.json();
        const { user, permissions, token } = result; // TODO レスポンスの型チェック
        dispatch(userSlice.actions.success());
        dispatch(userSlice.actions.setUserState({
          ...user,
          permissions: permissions && Array.isArray(permissions) ? permissions : [],
          zaiko: {
            bumons: user.centers && typeof user.centers === "string" ?
              Array.from(
                new Set(user.centers.split(",").map(center => center.substring(0, 2)))
              ) : null,
            centers: user.centers && typeof user.centers === "string" ? user.centers.split(",") : null,
          },
          tokubai: {
            bumons: user.tokubai_center_cd && typeof user.tokubai_center_cd === "string" ?
              Array.from(
                new Set(user.tokubai_center_cd.split(",").map(center => center.substring(0, 2)))
              ) : null,
            centers: user.tokubai_center_cd && typeof user.tokubai_center_cd === "string" ? user.tokubai_center_cd.split(",") : null,
          },
        }));

        if(token) {
          //他システム遷移用に必要
          //Cookie
          setCookie(null, TOKEN_COOKIE_NAME, token, {
            maxAge: parseInt(process.env.NEXT_PUBLIC_AUTHTOKEN_ALIVE_MIN) * 60, //60分
            domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
            path: '/',
          });
        }

        //権限チェック
        if (!checkPermission(location.href, permissions)) {
          console.log("閲覧権限なし");
          router.push('/nopermissions');
          return;
        }

        // フックの状態を認証済みに変更
        setState("authorized");
        // 認証が必要なpostを先へ進めるようにする
        fetchUtil.authorized(token);

      } catch (e) {
        dispatch(userSlice.actions.error(e));
        fetchUtil.authorizationFailure(e);
        throw e;
      }
    })();
  }, [router, state, setState, dispatch, userStore]);

  return state;
}

// 認証OKで子コンポーネントを描画するコンポーネント
function CheckAuth({ children }: Props) {
  const state = useAuthState();

  switch (state) {
  case null:
    // URL(`?code=xxx`がある状態)が確定しないタイミングでリクエストを投げると
    // ブラウザがCookieを付与しないケースがあるため、
    // このタイミングでは子コンポーネントを描画(子コンポーネントからのリクエスト発行を抑制するため)しない
    return <></>;

  case "begin":
    // 読み込み中のくるくるを出さずに画面を描画する。
    // 後続のAPIアクセスが未認証でこけないように、認証が解決するまで先へ進めないようにしている。
    return <>{children}</>;

  case "unauthorized":
    // 認証が必要なため、画面遷移
    window.location.href = SSO_ENDPOINT;
    return <>{}</>;

  case "authorized":
    return <>{children}</>;
  }
}

//Export
export default CheckAuth;


